import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProListingItemComponent } from './pro-listing-item.component';
import { ProListingItemWaitingComponent } from './pro-listing-item-waiting/pro-listing-item-waiting.component';
import { KzTagModule } from '../../../../../../kz-ui/ui/tag/kz-tag.module';
import { KzBadgeModule } from '../../../../../../kz-ui/ui/badge/kz-badge.module';
import { KzButtonModule } from '../../../../../../kz-ui/ui/form/button/kz-button.module';
import { KzTooltipModule } from '../../../../../../kz-ui/ui/tooltip/kz-tooltip.module';
import { KzClickOutsideModule } from '../../../../../../kz-ui/ui/click-outside/kz-click-outside.module';
import { ContentPlaceholderModule } from '../../../../../../kz-ui/ui/content-placehoder/content-placeholder.module';
import { ImgResizeModule } from '../../../../../../shared/components/img-resize/img-resize.module';
import { UtilsModule } from '../../../../../../utils/utils.module';
import { ProSharedModule } from '../../../components/pro-shared.module';
import { RouterModule } from '@angular/router';
import { ProfilePreviewProModule } from '../../../../../../shared/components/pro/profile-preview-pro/profile-preview-pro.module';
import { KzCardModule } from '../../../../../../kz-ui/ui/card/kz-card.module';
import { KzIconsModule } from '../../../../../../kz-ui/ui/icon/kz-icons.module';
import { ProPriceModule } from '../../../../../../shared/components/pro/pro-price/pro-price.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UtilsModule,
    ProSharedModule,
    ImgResizeModule,
    ContentPlaceholderModule,
    KzTagModule,
    KzBadgeModule,
    KzButtonModule,
    KzTooltipModule,
    KzClickOutsideModule,
    ProfilePreviewProModule,
    KzCardModule,
    KzIconsModule,
    ProPriceModule,
  ],
  exports: [
    ProListingItemComponent,
    ProListingItemWaitingComponent,
  ],
  declarations: [
    ProListingItemComponent,
    ProListingItemWaitingComponent,
  ]
})
export class ProListingItemModule { }
